import { createContext, useContext, useState, useEffect } from "react"

const LanguageContext = createContext()

export const useLanguage = () => {
  const context = useContext(LanguageContext)
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider")
  }
  return context
}

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Obtener idioma guardado del localStorage o usar español por defecto
    return localStorage.getItem("language") || "es"
  })

  useEffect(() => {
    // Guardar idioma en localStorage cuando cambie
    localStorage.setItem("language", language)
  }, [language])

  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage)
  }

  const value = {
    language,
    setLanguage, // Added setLanguage for compatibility
    changeLanguage,
    isSpanish: language === "es",
    isEnglish: language === "en",
  }

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
}
